'use client';

export { useUtmTracking } from '@workspace/lib/hooks/analytics/use-utm-tracking';
export type { UseUtmTrackingOutput } from '@workspace/lib/hooks/analytics/use-utm-tracking';
